import * as React from "react";
import { IconProps } from "./types";

export const ArrowNarrowDownIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M12 4V20M12 20L18 14M12 20L6 14"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          stroke={color}
        />
      </svg>
    );
  },
);
(ArrowNarrowDownIcon as React.FunctionComponent).displayName =
  "ArrowNarrowDownIcon";

export default ArrowNarrowDownIcon;
